import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionButton } from 'ui/actionButton/ActionButton';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { UnarchiveGlcProps } from './UnarchiveGlc.types';

export const UnarchiveGlc = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
  selectedGlc,
}: UnarchiveGlcProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <ActionButton type="unarchive" onClick={onModalOpen} />

      <ActionModal
        header={formatMessage({ id: AppMessages['glc.unarchive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['glc.unarchive.submitButton'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['glc.unarchive.subtitle'] })} {selectedGlc.nazwa}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['glc.unarchive.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
